import { createMediaSpec, defaultAttrs } from './media';

/**
 * @name mediaInline_node
 */

export const mediaInline = createMediaSpec(defaultAttrs, true);